import { render, staticRenderFns } from "./ArquivosFinalizados.vue?vue&type=template&id=5ab67dcc"
import script from "./ArquivosFinalizados.vue?vue&type=script&lang=js"
export * from "./ArquivosFinalizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports